import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["list", "template", "addButton"]

  connect() {
    this.updateAddButton()
  }

  add() {
    const content = this.templateTarget.content.cloneNode(true)
    const index = `${Date.now()}${Math.floor(Math.random() * 1000)}`
    this.assignNestedRecordIndex(content, index)
    this.listTarget.appendChild(content)
    this.updateAddButton()
  }

  assignNestedRecordIndex(content, index) {
    content.querySelectorAll("[name*='[NEW_RECORD]']").forEach((field) => {
      field.name = field.name.replace(/NEW_RECORD/g, index)
    })

    content.querySelectorAll("[id*='[NEW_RECORD]']").forEach((field) => {
      field.id = field.id.replace(/NEW_RECORD/g, index)
    })

    content.querySelectorAll("label[for*='[NEW_RECORD]']").forEach((label) => {
      label.htmlFor = label.htmlFor.replace(/NEW_RECORD/g, index)
    })
  }

  remove(event) {
    const row = event.target.closest("[data-payment-qr-row]")
    if (!row) return

    const destroyField = row.querySelector("input[name*='[_destroy]']")
    const idField = row.querySelector("input[name*='[id]']")

    if (idField?.value && destroyField) {
      destroyField.value = "1"
      row.classList.add("hidden")
    } else {
      row.remove()
    }

    this.updateAddButton()
  }

  updateAddButton() {
    if (!this.hasAddButtonTarget) return

    const visibleRows = this.listTarget.querySelectorAll(
      "[data-payment-qr-row]:not(.hidden)",
    ).length

    this.addButtonTarget.hidden = visibleRows >= this.maxValue
  }

  static values = {
    max: { type: Number, default: 3 },
  }
}
